import { gql } from '@apollo/client';

const IMPORT_ISSUE_FIELDS = `
  rowNumber
  caseId
  reason
`;

// Dry run. Writes nothing — the user reviews this before committing.
export const VALIDATE_CASE_ID_IMPORT = gql`
  mutation validateCaseIdImport($input: CaseIdImportInput!) {
    report: validateCaseIdImport(input: $input) {
      totalRows
      validRows
      nonConforming { ${IMPORT_ISSUE_FIELDS} }
      duplicatesInFile { ${IMPORT_ISSUE_FIELDS} }
      collisions { ${IMPORT_ISSUE_FIELDS} }
      missingName { ${IMPORT_ISSUE_FIELDS} }
    }
  }
`;

// Commits the reviewed set. Re-validates server-side and writes nothing at all if anything fails.
export const COMMIT_CASE_ID_IMPORT = gql`
  mutation commitCaseIdImport($input: CaseIdImportInput!) {
    result: commitCaseIdImport(input: $input) {
      imported
      highestHousehold
      highestSequence
    }
  }
`;
